module.exports = __webpack_public_path__ + "static/img/news5.2a95d03.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/dynamic/news5.jpg
// module id = BUcc
// module chunks = 1